import { Box } from '@mui/material';
import { Title } from '@ui/components';
import { FormattedMessage } from 'react-intl';
import { Fragment } from '../../../../../types';
import { audiogramHelpers } from '../helpers';
import { VariantGenerationStatus } from './VariantGenerationStatus';

export function AudiogramGenerationStatus({ fragment }: { fragment: Fragment }) {
  const variants = [
    ...audiogramHelpers.getInProgressVariants(fragment),
    ...audiogramHelpers.getFailedVariants(fragment),
  ];

  if (!variants.length) {
    return null;
  }

  return (
    <Box mb={2}>
      <Title className="mb-3 font-size-base">
        <FormattedMessage
          id="audiogram.audiogramsInProgress"
          defaultMessage="Audiograms en proceso"
        />
      </Title>
      {variants.map((variant) => (
        <VariantGenerationStatus key={variant.variant} fragment={fragment} variant={variant} />
      ))}
    </Box>
  );
}
